import { FC, Suspense } from 'react';
import lazyLoader from 'utils/lazyLoader';

import { Props } from './types';

const PrivacyPolicyLazy = lazyLoader(
  () => import('./PrivacyPolicy' /* webpackChunkName: "privacy-policy" */),
);

const PrivacyPolicy: FC<Props> = (props) => {
  return (
    <Suspense fallback={null}>
      <PrivacyPolicyLazy {...props} />
    </Suspense>
  );
};

export default PrivacyPolicy;
